var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cashbookHeader"},[_c('div',{staticClass:"headerTitle"},[_c('h2',[_vm._v(" "+_vm._s(_vm.headerTitle)+" ")])]),_c('div',{staticClass:"headerToolbar"},[_vm._t("toolbar")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }